/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc, collection, addDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import {
  Check,
  RefreshCw,
  Info,
  Phone,
  AlertTriangle,
  ChevronDown,
  Users2,
  TrendingUp,
  Truck,
  ShieldCheck,
  Clock3,
  Sparkles,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

const deliveryCompanies = [
  { id: "ZR Express", name: "ZR Express" },
  { id: "ecotrack", name: "Ecotrack" },
  { id: "DHD", name: "DHD" },
  { id: "maystro", name: "Maystro" },
  { id: "yalidine", name: "Yalidine" },
  { id: "nordetouest", name: "Nord Et Ouest" },
  { id: "guepex", name: "Guepex" },
  { id: "elogistia", name: "Elogistia" },
  { id: "zimou", name: "Zimou Express" },
  { id: "colivraison", name: "Colivraison Express" },
  { id: "mdm", name: "MDM Express" },
  { id: "ameex", name: "Ameex" },
  { id: "other", name: "أخرى / Autre / Other" },
];

export default function ActivationFoorCallRequest({ onClose }) {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const orders = useSelector((state) => state.OrdersReducer || []);
  const products = useSelector((state) => state.ProductsReducer || []);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    primaryPhone: "",
    secondaryPhone: "",
    estimatedOrdersPerMonth: "",
    deliveryCompany: "",
  });

  const [errors, setErrors] = useState({});

  const showAlert = (
    icon,
    title,
    text = "",
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok"),
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      position: "center",
      backdrop: "rgba(0,0,0,0.7)",
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validation du numéro principal
    if (!formData.primaryPhone.trim()) {
      newErrors.primaryPhone = t(
        "services.foorCall.validation.primaryPhoneRequired",
      );
    } else if (
      !/^0[567]\d{8}$/.test(formData.primaryPhone.replace(/\s/g, ""))
    ) {
      newErrors.primaryPhone = t(
        "services.foorCall.validation.primaryPhoneInvalid",
      );
    }

    // Validation du numéro secondaire (optionnel)
    if (
      formData.secondaryPhone.trim() &&
      !/^0[567]\d{8}$/.test(formData.secondaryPhone.replace(/\s/g, ""))
    ) {
      newErrors.secondaryPhone = t(
        "services.foorCall.validation.secondaryPhoneInvalid",
      );
    }

    // Validation de l'estimation
    if (!formData.estimatedOrdersPerMonth) {
      newErrors.estimatedOrdersPerMonth = t(
        "services.foorCall.validation.estimatedOrdersRequired",
      );
    } else if (
      isNaN(formData.estimatedOrdersPerMonth) ||
      parseInt(formData.estimatedOrdersPerMonth) <= 0
    ) {
      newErrors.estimatedOrdersPerMonth = t(
        "services.foorCall.validation.estimatedOrdersInvalid",
      );
    }

    // Validation de la société de livraison
    if (!formData.deliveryCompany) {
      newErrors.deliveryCompany = t(
        "services.foorCall.validation.deliveryCompanyRequired",
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isFormValid = () => {
    return (
      formData.primaryPhone.trim() &&
      /^0[567]\d{8}$/.test(formData.primaryPhone.replace(/\s/g, "")) &&
      formData.estimatedOrdersPerMonth &&
      !isNaN(formData.estimatedOrdersPerMonth) &&
      parseInt(formData.estimatedOrdersPerMonth) > 0 &&
      formData.deliveryCompany &&
      (!formData.secondaryPhone.trim() ||
        /^0[567]\d{8}$/.test(formData.secondaryPhone.replace(/\s/g, "")))
    );
  };

  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
    // Clear error for this field when user starts typing
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: "",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      await showAlert(
        "warning",
        t("services.foorCall.alerts.validationError"),
        t("services.foorCall.alerts.pleaseFixErrors"),
      );
      return;
    }

    try {
      setLoading(true);
      apicache(account, products);

      // Ajouter la demande à la collection FoorCall
      const foorCallRef = collection(db, "foorcall");
      const requestData = {
        storeId: store.id,
        user: account.user,
        primaryPhone: formData.primaryPhone,
        secondaryPhone: formData.secondaryPhone || "",
        estimatedOrdersPerMonth: parseInt(formData.estimatedOrdersPerMonth),
        realorderscount: orders.length,
        deliveryCompany: formData.deliveryCompany,
        status: "pending",
        createdAt: new Date(),
        updatedAt: new Date(),
        storeName: account.name || "",
        storeUrl: account.store || "",
        sellerEmail: account.email || "",
      };

      await addDoc(foorCallRef, requestData);

      // Mettre à jour le store pour activer le service FoorCall
      const updatedStoreData = {
        ...store,
        foorCallRequestId: true,
      };

      await saveStoreDraft(doc(db, "store", store.id), store, updatedStoreData);
      dispatch(applyStoreDraft(store, updatedStoreData));

      setLoading(false);

      await showAlert(
        "success",
        t("services.foorCall.alerts.requestSubmitted"),
        t("services.foorCall.alerts.requestSubmittedDesc"),
      );

      onClose();
    } catch (error) {
      setLoading(false);
      console.error("Error submitting FoorCall request:", error);

      await showAlert(
        "error",
        t("services.foorCall.alerts.submissionError"),
        error.message || t("services.foorCall.alerts.tryAgainLater"),
      );
    }
  };

  // Check if FoorCall is already requested
  const isFoorCallRequested = store?.foorCallRequestId;

  if (isFoorCallRequested) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-2xl shadow-sm p-8 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
          <div className="py-6 text-center">
            <div className="mb-5 flex justify-center">
              <div className="relative w-20 h-20 bg-green-50 rounded-full flex items-center justify-center dark:!bg-[#1a2e20]">
                <div className="absolute inset-0 rounded-full bg-green-400/20 animate-pulse" />
                <Check size={36} className="relative text-green-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#5a2b73] dark:text-[#c9a8e0] mb-3">
              {t("services.foorCall.alreadyRequested")}
            </h3>
            <p className="text-gray-600 dark:!text-gray-400 mb-5 max-w-md mx-auto leading-relaxed">
              {t("services.foorCall.requestPending")}
            </p>
            <div className="inline-flex items-center gap-2 bg-[#fbf8fc] dark:!bg-[#141414] border border-[#e9d9f2] dark:!border-[#3c3a3d] rounded-full px-4 py-2">
              <Clock3
                size={15}
                className="text-[#5a2b73] dark:text-[#c9a8e0]"
              />
              <p className="text-sm text-gray-600 dark:!text-gray-400">
                {t("services.foorCall.contactSupport")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const inputBaseClass =
    "w-full p-3 pr-11 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#e9d9f2] focus:border-[#9b59bf] transition-all dark:!bg-[#141414] dark:!border-[#3c3a3d] dark:!text-gray-200";

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
        {/* ══ رأس النموذج ══ */}
        <div className="mb-6">
          <div className="flex items-start justify-between gap-3 mb-3 flex-wrap">
            <div className="flex items-center gap-3">
              <span className="w-12 h-12 rounded-2xl bg-[#5a2b73] flex items-center justify-center text-white shrink-0">
                <Phone size={22} />
              </span>
              <div>
                <h3 className="text-xl font-bold text-[#5a2b73] dark:text-[#c9a8e0]">
                  {t("services.foorCall.title")}
                </h3>
                <p className="text-gray-500 dark:!text-gray-400 text-sm mt-0.5">
                  {t("services.foorCall.description")}
                </p>
              </div>
            </div>
            <span className="inline-flex items-center gap-1.5 bg-[#f3e8ff] dark:!bg-[#282347] text-[#5a2b73] dark:text-[#c9a8e0] px-3 py-1.5 rounded-full text-xs font-bold whitespace-nowrap">
              <Sparkles size={13} />
              {t("ui.underMinute")}
            </span>
          </div>

          {/* Info Box */}
          <div className="bg-blue-50 rounded-2xl border border-blue-200 p-4 flex gap-3 dark:!bg-[#16233a] dark:!border-[#233c5e]">
            <span className="w-9 h-9 rounded-xl bg-blue-100 dark:!bg-[#1c2f4d] flex items-center justify-center shrink-0">
              <Info size={17} className="text-blue-600 dark:!text-blue-400" />
            </span>
            <div>
              <p className="font-bold text-blue-800 dark:!text-blue-400 mb-0.5 text-sm">
                {t("services.foorCall.infoTitle")}
              </p>
              <p className="text-blue-700 dark:!text-gray-300 text-sm leading-relaxed">
                {t("services.foorCall.infoDescription")}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* ══ قسم: معلومات التواصل ══ */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Users2
                size={16}
                className="text-[#5a2b73] dark:text-[#c9a8e0]"
              />
              <h4 className="text-sm font-bold text-gray-700 dark:text-gray-200">
                {t("ui.contactInfo")}
              </h4>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Primary Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
                  {t("services.foorCall.primaryPhone")}{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Phone
                    size={16}
                    className="absolute top-1/2 -translate-y-1/2 right-3.5 text-gray-400"
                  />
                  <input
                    type="tel"
                    placeholder={t("services.foorCall.primaryPhonePlaceholder")}
                    value={formData.primaryPhone}
                    onChange={(e) =>
                      handleInputChange(
                        "primaryPhone",
                        e.target.value.replace(/[^\d]/g, ""),
                      )
                    }
                    className={`${inputBaseClass} ${
                      errors.primaryPhone ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                </div>
                {errors.primaryPhone && (
                  <p className="text-red-500 text-xs mt-1.5 flex items-center gap-1">
                    <AlertTriangle size={13} />
                    {errors.primaryPhone}
                  </p>
                )}
              </div>

              {/* Secondary Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
                  {t("services.foorCall.secondaryPhone")}
                </label>
                <div className="relative">
                  <Phone
                    size={16}
                    className="absolute top-1/2 -translate-y-1/2 right-3.5 text-gray-400"
                  />
                  <input
                    type="tel"
                    placeholder={t(
                      "services.foorCall.secondaryPhonePlaceholder",
                    )}
                    value={formData.secondaryPhone}
                    onChange={(e) =>
                      handleInputChange(
                        "secondaryPhone",
                        e.target.value.replace(/[^\d]/g, ""),
                      )
                    }
                    className={`${inputBaseClass} ${
                      errors.secondaryPhone
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  />
                </div>
                {errors.secondaryPhone ? (
                  <p className="text-red-500 text-xs mt-1.5 flex items-center gap-1">
                    <AlertTriangle size={13} />
                    {errors.secondaryPhone}
                  </p>
                ) : (
                  <p className="text-gray-400 text-xs mt-1.5">
                    {t("services.foorCall.optionalField")}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* ══ قسم: معلومات النشاط ══ */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <TrendingUp
                size={16}
                className="text-[#5a2b73] dark:text-[#c9a8e0]"
              />
              <h4 className="text-sm font-bold text-gray-700 dark:text-gray-200">
                {t("ui.businessInfo")}
              </h4>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Estimated Orders Per Month */}
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
                  {t("services.foorCall.estimatedOrders")}{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <TrendingUp
                    size={16}
                    className="absolute top-1/2 -translate-y-1/2 right-3.5 text-gray-400"
                  />
                  <input
                    type="number"
                    min="1"
                    placeholder={t(
                      "services.foorCall.estimatedOrdersPlaceholder",
                    )}
                    value={formData.estimatedOrdersPerMonth}
                    onChange={(e) =>
                      handleInputChange(
                        "estimatedOrdersPerMonth",
                        e.target.value,
                      )
                    }
                    className={`${inputBaseClass} ${
                      errors.estimatedOrdersPerMonth
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  />
                </div>
                {errors.estimatedOrdersPerMonth && (
                  <p className="text-red-500 text-xs mt-1.5 flex items-center gap-1">
                    <AlertTriangle size={13} />
                    {errors.estimatedOrdersPerMonth}
                  </p>
                )}
              </div>

              {/* Delivery Company */}
              <div>
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-2">
                  {t("services.foorCall.deliveryCompany")}{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Truck
                    size={16}
                    className="absolute top-1/2 -translate-y-1/2 right-3.5 text-gray-400 pointer-events-none"
                  />
                  <select
                    value={formData.deliveryCompany}
                    onChange={(e) =>
                      handleInputChange("deliveryCompany", e.target.value)
                    }
                    className={`${inputBaseClass} pl-9 appearance-none bg-white cursor-pointer ${
                      errors.deliveryCompany
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  >
                    <option value="">
                      {t("services.foorCall.selectCompany")}
                    </option>
                    {deliveryCompanies.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                  <ChevronDown
                    size={16}
                    className="absolute top-1/2 -translate-y-1/2 left-3.5 text-gray-400 pointer-events-none"
                  />
                </div>
                {errors.deliveryCompany && (
                  <p className="text-red-500 text-xs mt-1.5 flex items-center gap-1">
                    <AlertTriangle size={13} />
                    {errors.deliveryCompany}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Info Section */}
          <div className="bg-amber-50 p-4 md:p-5 rounded-2xl border border-amber-100 dark:!bg-[#2a2313] dark:!border-[#3c3a3d]">
            <h4 className="font-bold text-amber-800 mb-3 flex items-center gap-2 dark:!text-amber-400">
              <Info size={17} />
              {t("services.foorCall.importantInfo")}
            </h4>
            <div className="space-y-2">
              {[
                t("services.foorCall.info1"),
                t("services.foorCall.info2"),
                t("services.foorCall.info3"),
              ].map((info, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <span className="w-5 h-5 rounded-full bg-amber-100 dark:!bg-[#3a2f14] flex items-center justify-center shrink-0 mt-0.5">
                    <Check
                      size={11}
                      className="text-amber-700 dark:!text-amber-400"
                    />
                  </span>
                  <p className="text-sm text-gray-700 dark:!text-gray-300 leading-relaxed">
                    {info}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              disabled={loading || !isFormValid()}
              className={`w-full px-6 py-3.5 rounded-xl transition-colors flex items-center justify-center font-bold shadow-sm
                ${
                  loading || !isFormValid()
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed opacity-70 dark:!bg-[#2a2a2b] dark:!text-gray-500"
                    : "bg-[#5a2b73] hover:bg-[#4a2360] text-white"
                }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="ml-2 animate-spin" size={18} />
                  {t("services.foorCall.submitting")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("services.foorCall.submitRequest")}
                </>
              )}
            </button>
            <p className="flex items-center justify-center gap-1.5 text-xs text-gray-400 dark:text-gray-500 mt-3">
              <ShieldCheck size={13} />
              {t("ui.requestReview")}
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
